import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "type", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(`${
      _ctx.isEditable ? '' : 'cursor-auto'
    } w-full border-2 px-3 py-2 resize-none font-mono text-sm focus:outline-none bg-gray-50 hover:border-primary-100 dark:bg-dark-400 dark:border-dark-400`),
    disabled: !_ctx.isEditable,
    style: _normalizeStyle([{"transition":"border-color 0.5s"}, { width: _ctx.width, borderRadius: _ctx.radius }]),
    type: _ctx.type,
    value: _ctx.value,
    wrap: "off",
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeText && _ctx.changeText(...args)))
  }, null, 46, _hoisted_1))
}